<template>
  <div class="graybox">
    <div v-if="summary_preset">
    <div  class="row summary-item" v-for="data in summary" :key="data.index">
			<div class="col-sm-12 summary-item-content">
				<div class="sumimg">
					<img src="../assets/icon-true.png" class="img-responsive" v-if="data.status=='Yes'">
					<img src="../assets/download.png" class="img-responsive" v-else>
				</div>
				<div class="summary-text">
					<p><span class="smtext">Name of the Milestones</span> : {{data.name}}</p>
					<p><span class="smtext">Completed Date</span> : {{data.date}}</p>
					<p><span class="smtext">Status</span> : {{data.status}}</p>
				</div>
			</div>
		</div>
    </div>
    <div v-else>
      No summary
    </div>
	</div>
</template>
<script>
import summary from '../services/summary'
export default {
    name:'activity-summary',
    props:['subscription'],
     watch:{
        subscription: function (data){
            this.PropData=data
             this.GetSummary()
        }
    },
    data() {
        return {
           summary: [],
           summary_preset:false
        }
    },
    methods: {
      GetSummary(){
            summary.get({type:this.PropData.type,id:this.PropData.id})
            .then(response=>{
               this.summary=response.data.data;
               if(this.summary.length>0){
                   this.summary_preset=true
               }
            });
    }
    }
}

</script>